export default {
  lang: "English",

  // Dextra Content
  welcome: "Dextra Video Consultation",
  s_services: "Dextra Services",
  s_tracking: "Service Tracking",
  s_record: "Document Services",
  s_redirect: "Service Redirect",
  s_adress: "Address Services",
  s_feedback: "Customer Support",
  privacy: "Your privacy is important. Conversations are treated confidentially and are not recorded.",
  agentAvailability: "Agent Availability",
  available: "Available",
  unavailable: "Unavailable",
  connecting_title: "Connecting...",
  connecting_message: "Please wait a moment.",
  cancel: "Cancel",
  button_start: "Start here",
  
  // Agent status translations
  agent_online: "Agent Online",
  agent_available: "Agent is available",
  services_title: "Our Services",
  
  // Media permissions
  mediaPermissions: {
    title: "Camera and Microphone Required",
    description: "For video consultation, we need access to your camera and microphone. Please allow access when your browser asks.",
    cameraRequired: "Camera for Video",
    microphoneRequired: "Microphone for Audio",
    allowAccess: "Allow Access",
    requesting: "Requesting...",
    skip: "Skip",
    helpText: "You can change these permissions later in your browser settings."
  }
}
